import React from 'react'
import { useSelector } from 'react-redux'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import { Flex } from '../Flex'
import { Portal } from '../Portal'

import { errorsSelector } from './store'
import { Toast } from './Toast'

export const Errors = () => {
  const errors = useSelector(errorsSelector)

  return (
    <Portal>
      <Flex
        zIndex={900}
        position="fixed"
        right={0}
        top={0}
        flexDirection="column"
        p={2}>
        <TransitionGroup>
          {errors.map(error => (
            <CSSTransition key={error.id} unmountOnExit timeout={400}>
              <Toast error={error} />
            </CSSTransition>
          ))}
        </TransitionGroup>
      </Flex>
    </Portal>
  )
}
